export const API_BASE_URL = 'https://api.journal.iosx.in/api/v1/'